import { DeleteComment } from './delete-comment'

export const Comment = {
  DeleteComment
}
